import { useQuery } from '@tanstack/react-query';
import Option from '../models/Option';
import Price from '../models/Price';

export default function useOptionsForPackage(packageId, schoolId) {
  const priceScope = Price.where({ for_school: schoolId, hasPrice: true });

  return useQuery(['option-for-package', packageId], () => (
    Option
      .includes(['image_types', 'prices'])
      .merge({ prices: priceScope })
      .where({ packageId, hasCode: true })
      .order('abbreviation')
      .all()
      .then((res) => res.data)
  ), { enabled: !!(packageId && schoolId), staleTime: 0 });
}
